import { Link, useNavigate } from 'react-router-dom';
import { Menu, X, User, LogOut } from 'lucide-react';
import { useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';

export default function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center group" data-testid="logo-link">
            <img 
              src="https://customer-assets.emergentagent.com/job_0848332d-e034-4129-a373-6813f066dde6/artifacts/l1pyibi2_logo-highres.png" 
              alt="AirVia - cheap flights subscription India, Delhi to Mumbai" 
              className="h-16 w-auto animate-bounce-slow"
            />
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8">
            <Link to="/subscription-plans" className="text-slate-700 hover:text-amber-600 transition-colors font-medium" data-testid="nav-plans-link">
              Get Started
            </Link>
            <Link to="/faq" className="text-slate-700 hover:text-amber-600 transition-colors font-medium" data-testid="nav-faq-link">
              FAQ
            </Link>
            <Link to="/blog" className="text-slate-700 hover:text-amber-600 transition-colors font-medium" data-testid="nav-blog-link">
              Blog
            </Link>
            <Link to="/contact" className="text-slate-700 hover:text-amber-600 transition-colors font-medium" data-testid="nav-contact-link">
              Contact
            </Link>
            
            {user ? (
              <>
                <Link to="/dashboard" data-testid="nav-dashboard-link">
                  <Button variant="outline" className="rounded-full">
                    <User className="w-4 h-4 mr-2" />
                    Dashboard
                  </Button>
                </Link>
                <Button onClick={handleLogout} variant="ghost" className="rounded-full" data-testid="nav-logout-btn">
                  <LogOut className="w-4 h-4 mr-2" />
                  Logout
                </Button>
              </>
            ) : (
              <>
                <Link to="/login" data-testid="nav-login-link">
                  <Button variant="outline" className="rounded-full">
                    Login
                  </Button>
                </Link>
                <Link to="/register" data-testid="nav-register-link">
                  <Button className="rounded-full bg-amber-600 hover:bg-amber-700 text-white">
                    Sign Up
                  </Button>
                </Link>
              </>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden"
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? <X /> : <Menu />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 space-y-4 border-t border-slate-200">
            <Link to="/subscription-plans" className="block text-slate-700 hover:text-amber-600" data-testid="mobile-nav-plans-link">
              Get Started
            </Link>
            <Link to="/faq" className="block text-slate-700 hover:text-amber-600" data-testid="mobile-nav-faq-link">
              FAQ
            </Link>
            <Link to="/blog" className="block text-slate-700 hover:text-amber-600" data-testid="mobile-nav-blog-link">
              Blog
            </Link>
            <Link to="/contact" className="block text-slate-700 hover:text-amber-600" data-testid="mobile-nav-contact-link">
              Contact
            </Link>
            {user ? (
              <>
                <Link to="/dashboard" className="block text-slate-700 hover:text-amber-600" data-testid="mobile-nav-dashboard-link">
                  Dashboard
                </Link>
                <button onClick={handleLogout} className="text-left text-slate-700 hover:text-amber-600" data-testid="mobile-nav-logout-btn">
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="block text-slate-700 hover:text-amber-600" data-testid="mobile-nav-login-link">
                  Login
                </Link>
                <Link to="/register" className="block text-slate-700 hover:text-amber-600" data-testid="mobile-nav-register-link">
                  Sign Up
                </Link>
              </>
            )}
          </div>
        )}
      </div>
    </nav>
  );
}
